import Title from '../../microComponents/elements/Title';
import ComponentCard from '../../microComponents/elements/ComponentCard';
import CreatorTable from '../../microComponents/tablePages/CreatorTable';
import PrintQueueColumn from './PrintQueueColumn';
import React from "react";
import ExpandedPrintQueue from "./ExpandedPrintQueue";


const PrintQueue = () => {
    const [columns] = PrintQueueColumn();

    return (<div>
            <ComponentCard>
                <div className='flex justify-between'>
                    <Title>صف پرینت
                    </Title>
                </div>
            </ComponentCard> <ComponentCard>

            <CreatorTable columns={columns}
                          expandable={{
                              expandedRowRender: (row) => (

                                  <ExpandedPrintQueue item={row}/>

                              ),
                              // rowExpandable: (record) => record.name !== 'Not Expandable',
                          }}
                          listAddress='PrintQueue'/>

        </ComponentCard>
    </div>
    );
};


export default PrintQueue;